import { render, staticRenderFns } from "./bv-picker.vue?vue&type=template&id=6e5d3109&scoped=true"
import script from "./bv-picker.vue?vue&type=script&lang=js"
export * from "./bv-picker.vue?vue&type=script&lang=js"
import style0 from "./bv-picker.vue?vue&type=style&index=0&id=6e5d3109&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../apps/gouwubao/node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5d3109",
  null
  
)

export default component.exports